/**
 * The Dutch names of the fixed choices a column shows, the same as the static options of the
 * register on the server (`STATUS_OPTIONS`, `SOURCE_OPTIONS`, `CONSENT_OPTIONS`). A value the
 * server adds later shows as it is until it is named here.
 */
export const STATUS_LABELS: Readonly<Record<string, string>> = { actief: 'Actief', inactief: 'Inactief' }

export const SOURCE_LABELS: Readonly<Record<string, string>> = {
  handmatig: 'Handmatig',
  import: 'Import',
  scan: 'Scan',
  migratie: 'Migratie',
}

export const CONSENT_LABELS: Readonly<Record<string, string>> = { opt_in: 'Opt-in', opt_out: 'Opt-out', unknown: 'Onbekend' }

export function labelOf(labels: Readonly<Record<string, string>>, value: string): string {
  return labels[value] ?? value
}
